import React, { useState, useEffect, memo } from "react"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import { makeStyles } from "@material-ui/core/styles"
import { useNavigate } from "react-router-dom"

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
}))

function RequestSnackbar(props) {
    const { snackbarOpen, message, status, handleSnackbarOpenStatus, redirectStatus, redirectPath } = props
    const classes = useStyles()
    const [open, setOpen] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        const initOpenStatus = () => {
            if (typeof snackbarOpen === "undefined") {
                if (message) setOpen(true)
            } else if (snackbarOpen) setOpen(true)
        }
        initOpenStatus()
    }, [message, snackbarOpen])

    useEffect(() => {
        if (handleSnackbarOpenStatus && typeof handleSnackbarOpenStatus === "function") {
            handleSnackbarOpenStatus(open)
        }
    }, [open])

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return
        }
        setOpen(false)
        if (redirectStatus) {
            navigate(redirectPath)
        }
    }

    return (
        <div className={classes.root}>
            <Snackbar open={open} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{ horizontal: "right", vertical: "top" }}>
                {status ? (
                    <Alert onClose={handleClose} severity="success">
                        {message}
                    </Alert>
                ) : (
                    <Alert onClose={handleClose} severity="error">
                        {message}
                    </Alert>
                )}
            </Snackbar>
        </div>
    )
}

export default memo(RequestSnackbar)
